/* eslint-disable @typescript-eslint/indent */
import { Component, Input, OnInit } from "@angular/core";
import { DataTableConfig } from "../data-table/data-table-service.type";
import { DataTable } from "../data-table/data-table.type";
import { PieChartTableService } from "./pie-chart-table.service";
import { Data, PieChartData } from "./pie-chart.type";

@Component({
  selector: "app-pie-chart",
  templateUrl: "./pie-chart.component.html",
  styleUrls: ["./pie-chart.component.scss"],
})
export class PieChartComponent implements OnInit {
  @Input() config: PieChartData;
  tableConfig: DataTable<Data>;

  constructor(private pieChartTableService: PieChartTableService) {}

  ngOnInit(): void {
    this.buildTables();
  }

  private buildTables = (): void => {
    const defaultTableConfig: DataTableConfig = {
      bodyHeight: this.config.bodyHeight,
      syncWithQueryParams: false,
      selection: { hidden: true },
      toolBar: {
        hidden: true,
      },
      shown: ["color", "label", "value"],
      actionColumn: { hidden: true },
      showNotificationAfterUpdate: false,
      queryParamsDetails: this.config.queryParamsDetails,
    };

    this.tableConfig = this.pieChartTableService.getTableConfig({
      ...defaultTableConfig,
      id: this.config.id,
    });
  };
}
